<p-select [options]="supportedLanguages"  [formControl]="control" optionValue="code" optionLabel="name" fluid />